var map = {
	"./tutorial-01.svg": "52e9",
	"./tutorial-02.svg": "8f62",
	"./tutorial-03.svg": "dd4b",
	"./tutorial-04.svg": "5216",
	"./tutorial-05.svg": "6f91",
	"./tutorial-06.svg": "7093",
	"./tutorial-07.svg": "d400",
	"./tutorial-08.svg": "a4d2",
	"./tutorial-09.svg": "660c",
	"./tutorial-10.svg": "bed9",
	"./tutorial-11.svg": "f7cd",
	"./tutorial-12.svg": "a2ce",
	"./tutorial-13.svg": "0c19"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2436";